import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Navbar from '../components/Navbar';

const BookmarksPage = ({ session, access }) => {
  const navigate = useNavigate();
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const { data } = await supabase
      .from('lesson_bookmarks')
      .select(`
        lesson_id,
        lessons (
          id, title, vimeo_url, duration_minutes, thumbnail_url, module_id,
          modules ( title, courses ( title, slug ) )
        )
      `)
      .eq('user_id', session.user.id);
    // Töröljük azokat, ahol a lecke már nem létezik
    setBookmarks((data || []).filter(b => b.lessons));
    setLoading(false);
  }, [session.user.id]);

  useEffect(() => { load(); }, [load]);

  // SEO: védett oldal — ne indexelje a Google
  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    const prevRobots = robots?.getAttribute('content');
    const prevTitle = document.title;
    if (robots) robots.setAttribute('content', 'noindex, nofollow');
    document.title = 'Mentett leckék — Web3 Kurzus Egyetem';
    return () => {
      if (robots) robots.setAttribute('content', prevRobots || 'index, follow');
      document.title = prevTitle;
    };
  }, []);

  const removeBookmark = async (lessonId) => {
    await supabase.from('lesson_bookmarks')
      .delete()
      .eq('user_id', session.user.id)
      .eq('lesson_id', lessonId);
    setBookmarks(prev => prev.filter(b => b.lesson_id !== lessonId));
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0d1117' }}>
      <Navbar access={access} />

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px' }}>
        <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 700, margin: '0 0 6px' }}>
          ❤️ Mentett leckék
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, margin: '0 0 28px' }}>
          A leckéknél a ❤️ gombbal mentett leckéid.
        </p>

        {loading ? (
          <p style={{ color: 'rgba(255,255,255,0.4)' }}>Betöltés...</p>
        ) : bookmarks.length === 0 ? (
          <div style={{
            background: 'rgba(255,255,255,0.03)',
            border: '0.5px solid rgba(255,255,255,0.08)',
            borderRadius: 12, padding: '28px 24px',
            color: 'rgba(255,255,255,0.5)', fontSize: 14, textAlign: 'center',
          }}>
            Még nincs mentett leckéd. A leckéknél a ❤️ gombbal menthetsz el leckéket.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {bookmarks.map(b => {
              const l = b.lessons;
              const courseTitle = l.modules?.courses?.title;
              const moduleTitle = l.modules?.title;
              return (
                <div
                  key={b.lesson_id}
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border: '0.5px solid rgba(255,255,255,0.08)',
                    borderRadius: 12, padding: 14,
                    display: 'flex', alignItems: 'center', gap: 14,
                    flexWrap: 'wrap',
                  }}
                >
                  {/* Thumbnail */}
                  {l.thumbnail_url ? (
                    <img
                      src={l.thumbnail_url}
                      alt=""
                      style={{ width: 80, height: 52, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }}
                    />
                  ) : (
                    <div style={{
                      width: 80, height: 52, borderRadius: 6, flexShrink: 0,
                      background: 'rgba(0,210,200,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
                    }}>▶</div>
                  )}

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 160 }}>
                    <div style={{ color: '#fff', fontSize: 14, fontWeight: 600, marginBottom: 3 }}>
                      {l.title}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12 }}>
                      {courseTitle}{courseTitle && moduleTitle ? ' → ' : ''}{moduleTitle}
                    </div>
                    {l.duration_minutes && (
                      <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, marginTop: 2 }}>
                        ⏱ {l.duration_minutes} perc
                      </div>
                    )}
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                    <button
                      onClick={() => navigate(`/lecke/${b.lesson_id}`)}
                      style={{
                        background: '#00D2C8', color: '#07070b',
                        border: 'none', borderRadius: 8, padding: '9px 16px',
                        fontWeight: 700, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap',
                      }}
                    >
                      Megnyitom →
                    </button>
                    <button
                      onClick={() => removeBookmark(b.lesson_id)}
                      title="Eltávolítás a mentettek közül"
                      style={{
                        background: 'rgba(239,68,68,0.1)',
                        border: '1px solid rgba(239,68,68,0.25)',
                        color: '#f87171', borderRadius: 8,
                        width: 34, height: 34, cursor: 'pointer', fontSize: 13, flexShrink: 0,
                      }}
                    >
                      ❌
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BookmarksPage;
